import { useHasScrollTop } from '@affine/component';
import * as ScrollArea from '@radix-ui/react-scroll-area';
import clsx from 'clsx';
import { type PropsWithChildren } from 'react';

import * as styles from './index.css';

interface SidebarContainerProps extends PropsWithChildren {
  className?: string;
  contentClassName?: string;
}

interface SidebarScrollableContainerProps extends SidebarContainerProps {
  contentLayout?: 'accordion';
}

export function SidebarContainer({
  children,
  className,
}: SidebarContainerProps) {
  return (
    <div className={clsx([styles.baseContainer, className])}>{children}</div>
  );
}

export function SidebarScrollableContainer({
  children,
  className,
  contentClassName,
  contentLayout,
}: SidebarScrollableContainerProps) {
  const [setContainer, hasScrollTop] = useHasScrollTop();
  return (
    <ScrollArea.Root
      className={clsx([
        styles.scrollableContainerRoot,
        contentLayout === 'accordion' &&
          styles.accordionScrollableContainerRoot,
        className,
      ])}
    >
      <div
        data-has-scroll-top={hasScrollTop}
        className={styles.scrollTopBorder}
      />
      <ScrollArea.Viewport
        className={clsx([
          styles.scrollableViewport,
          contentLayout === 'accordion' && styles.accordionScrollableViewport,
        ])}
        ref={setContainer}
      >
        <div
          className={clsx([
            styles.scrollableContainer,
            contentLayout === 'accordion' && styles.accordionScrollableContent,
            contentClassName,
          ])}
        >
          {children}
        </div>
      </ScrollArea.Viewport>
      <ScrollArea.Scrollbar
        forceMount
        orientation="vertical"
        className={clsx([
          styles.scrollbar,
          contentLayout === 'accordion' && styles.accordionScrollbar,
        ])}
      >
        <ScrollArea.Thumb className={styles.scrollbarThumb} />
      </ScrollArea.Scrollbar>
    </ScrollArea.Root>
  );
}
